'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { createViewPdfIntent } from '@/lib/files/services/files.intents'
import { DOT_SEPARATOR } from '@/lib/utils/text-utils'
import { Icon } from '@/ui/icons/icon/Icon'
import { Link } from '@/ui/links/link/Link.client'
import { useMemo } from 'react'

export type DocumentTagLinkProps = UiComponentProps<{
  /**  The name of the document */
  label: string

  /** The download link to the document */
  downloadLink: string
}>

export function DocumentTagLink({
  label,
  downloadLink,
  className,
  'data-testid': testId,
}: DocumentTagLinkProps): React.ReactElement {
  const downloadLinkIntent = useMemo(
    () => createViewPdfIntent({ pdfLink: downloadLink }),
    [downloadLink],
  )

  return (
    <Link
      variant="free"
      underlined="hover"
      href={downloadLink}
      opensInNewTab
      className={twMerge('font-bold', className)}
      data-testid={testId ?? 'document-tag-link'}
      tint="brand-1"
      trackingData={{
        event: 'gaEvent',
        eventCategory: 'fiche article / produit',
        eventAction: 'clic document',
        eventLabel: label,
      }}
      intent={downloadLinkIntent}
    >
      <div className="flex items-center gap-1 rounded-xs bg-brand-1-50 px-2 py-1 leading-light">
        <Icon.FileText size="sm" />
        <span>
          {label} {DOT_SEPARATOR} <span className="font-medium">PDF</span>
        </span>
      </div>
    </Link>
  )
}
